import React, { useState } from "react";
import "./index.css";

function App() {
  const [title, setTitle] = useState("");
  const [amount, setAmount] = useState("");
  const [type, setType] = useState("expense"); // income OR expense
  const [transactions, setTransactions] = useState([]);
  const [search, setSearch] = useState("");

  const addTransaction = () => {
    if (!title || !amount) return;

    const newTx = {
      id: Date.now(),
      title,
      amount: parseFloat(amount),
      type,
    };

    setTransactions([newTx, ...transactions]);
    setTitle("");
    setAmount("");
  };

  const deleteTransaction = (id) => {
    setTransactions(transactions.filter((tx) => tx.id !== id));
  };

  const filteredTx = transactions.filter((tx) =>
    tx.title.toLowerCase().includes(search.toLowerCase())
  );

  const income = transactions
    .filter((tx) => tx.type === "income")
    .reduce((acc, tx) => acc + tx.amount, 0);

  const expense = transactions
    .filter((tx) => tx.type === "expense")
    .reduce((acc, tx) => acc + tx.amount, 0);

  const balance = income - expense;

  return (
    <div className="container">
      <h1 className="main-title"> My Expense Manager </h1>

      {/* Balance Box */}
      <div className="balance-box">
        <div>
          <p>Total Balance</p>
          <h2>₹{balance}</h2>
        </div>
        <div>
          <p>Income</p>
          <h3 className="green">₹{income}</h3>
        </div>
        <div>
          <p>Expense</p>
          <h3 className="red">₹{expense}</h3>
        </div>
      </div>

      {/* Input Box */}
      <div className="input-box">
        <input
          type="text"
          placeholder="Title (e.g., Salary, Food)"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        <input
          type="number"
          placeholder="Amount ₹"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />

        {/* Income / Expense selector */}
        <select value={type} onChange={(e) => setType(e.target.value)}>
          <option value="income">Income</option>
          <option value="expense">Expense</option>
        </select>

        <button onClick={addTransaction}>Add</button>
      </div>

      {/* Search Bar */}
      <input
        className="search"
        type="text"
        placeholder="Search transactions..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {/* Transaction List */}
      <div className="list">
        {filteredTx.length === 0 ? (
          <p className="empty">No matching transactions</p>
        ) : (
          filteredTx.map((tx) => (
            <div className="item" key={tx.id}>
              <div>
                <b>{tx.title}</b> — ₹{tx.amount}
                <span className={tx.type === "income" ? "tag green-bg" : "tag red-bg"}>
                  {tx.type}
                </span>
              </div>

              <button className="delete" onClick={() => deleteTransaction(tx.id)}>
                Delete
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default App;
